import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { addToCart } from "../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import pricing from "../../assets/data/pricing.json";
import {
  updateAdminRequest,
  updateBusinessRequest,
  updateDomiciliationRequest,
  updateGrhRequest,
  updateJuridiqueRequest,
  updateManagementRequest,
  updateSalesRequest,
} from "../../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import serviceCode from "../../assets/data/serviceCode.json";
import { Image } from "react-bootstrap";

const banks = [
  { name: "BGFI", logo: "/images/bank/bgfi.webp" },
  { name: "BICEC", logo: "/images/bank/bi.webp" },
  { name: "AFRILAND FISRT BANK", logo: "/images/bank/afb.webp" },
  { name: "GOLDEN BANK", logo: "/images/bank/gb.webp" },
  { name: "SCB", logo: "/images/bank/scb.webp" },
  { name: "ECOBANK", logo: "/images/bank/ecobank.webp" },
  { name: "UBA", logo: "/images/bank/uba.webp" },
  { name: "BANQUE ATLANTIQUE", logo: "/images/bank/atlantique.webp" },
  { name: "CBC", logo: "/images/bank/commercial-bank.webp" },
  { name: "UBC", logo: "/images/bank/ubc.webp" },
];

function EditBank() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);
  const [bankName, setBankName] = useState(false);
  const {
    businessCreationRequest,
    domiciliationRequest,
    managementRequest,
    juridiqueRequest,
    adminRequest,
    grhRequest,
    salesRequest,
  } = useSelector((state) => state.request);
  const servicesList = useSelector((state) => state.serviceList.services);

  const handleBoxClick = async (bank) => {
    setSubmitting(true);

    let updatedServices = [...servicesList];
    updatedServices.push({
      code: serviceCode.oapi,
      billing: "lifetime",
    });
    if (cart.from === "creation") {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    } else if (cart.from === "domiciliation") {
      await dispatch(
        updateDomiciliationRequest(
          user.token,
          domiciliationRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    } else if (cart.from === "management") {
      await dispatch(
        updateManagementRequest(
          user.token,
          managementRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    } else if (cart.from === "admin") {
      await dispatch(
        updateAdminRequest(
          user.token,
          adminRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    } else if (cart.from === "juridique") {
      await dispatch(
        updateJuridiqueRequest(
          user.token,
          juridiqueRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    } else if (cart.from === "grh") {
      await dispatch(
        updateGrhRequest(
          user.token,
          grhRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    } else if (cart.from === "sales") {
      await dispatch(
        updateSalesRequest(
          user.token,
          salesRequest.reference,
          {
            services: [...updatedServices],
            bank: bank,
          },
          handleCallback
        )
      );
    }
  };

  const handleCallback = async ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          bank: {
            name: bankName,
            amount: pricing.bank,
          },
        })
      );
      await dispatch(
        addToServiceList({
          code: serviceCode.bank,
          billing: "lifetime",
        })
      );

      navigate(-1, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleSkipClick = () => {
    navigate(-1, { replace: true });
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />
      <Loader isLoading={submitting} />
      {/* Title Section */}
      <div className="container mt-3 text-center">
        <h4 className="text-2xl font-semibold">
          Dans quelle <span style={{ color: "#FF5500" }}>banque</span>{" "}
          envisagez-vous ouvrir le compte de votre {cart?.businessType} ?
        </h4>
      </div>

      {/* Bank Boxes Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <div
          className="bank-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)", // 5 colonnes sur grand écran
            gap: "20px", // Espacement entre les banques
            maxWidth: "800px", // Largeur max pour éviter l'étirement
          }}
        >
          {banks.map((bank, index) => (
            <div
              key={index}
              className="bank-box p-4 rounded-lg d-flex flex-column align-items-center"
              style={{
                border: "2px solid #ddd",
                borderRadius: "8px",
                cursor: "pointer",
                height: "120px",
                transition: "border-color 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.borderColor = "#FF5500")
              }
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#ddd")}
              onClick={() => {
                setBankName(bank.name);
                handleBoxClick(bank.name);
              }}
            >
              <Image
                src={bank.logo}
                alt={bank.name}
                className="img-fluid mb-3"
                style={{
                  height: "100px",
                  width: "100px",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
        </div>

        {/* Style responsive */}
        <style jsx>{`
          @media (max-width: 768px) {
            .bank-grid {
              grid-template-columns: repeat(
                2,
                1fr
              ) !important; /* 1 par ligne sur mobile */
            }
          }
        `}</style>
      </div>

      <div className="container text-center mt-3">
        <span
          onClick={handleSkipClick}
          style={{ color: "#3392FF", cursor: "pointer" }}
        >
          Retour
        </span>
      </div>
    </div>
  );
}

export default EditBank;
